import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function MoneyBagIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Union" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m8.83451 3.89799 0.87711 -2.1312c0.10947 -0.26599 0.17318 -0.59146 -0.04986 -0.75728 -0.91378 -0.679347 -4.45856 -0.679347 -5.37235 0 -0.22303 0.16582 -0.15932 0.49129 -0.04985 0.75728l0.88201 2.14312c-2.33859 0.64796 -3.62279 2.60605 -3.62279 5.6292 0 3.75419 1.98039 3.96089 5.5011 3.96089 3.52072 0 5.50112 -0.2067 5.50112 -3.96089 0 -3.04192 -1.3002 -5.00551 -3.66649 -5.64112Z"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M8.31292 7.02249s-0.49355 -0.55017 -1.29406 -0.48142c-0.8005 0.06876 -1.18636 0.56056 -1.18636 1.05372 0 1.43834 2.48042 0.44155 2.48042 1.91653 0 0.76038 -1.64536 1.29718 -2.62566 0.40257m1.42968 -4.34004v0.96127m0 3.83748v0.9613"
          strokeWidth="1"></path>
  </SvgIcon>
}
